import React, { useEffect } from 'react';
import {
  Container,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import MperitoCard from 'src/components/MperitoCard';
import Results from './Results';

import { fetchTestimonials } from 'src/actions/testimonialActions';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function TestimonialsList() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;

  const testimonials = useSelector((state) => state?.testimonial?.testimonials);
 
  useEffect(() => {
    dispatch(fetchTestimonials(customerId));
  }, [businessInfo]);

  useEffect(() => {

  }, [testimonials]);


  return (
    <Page
      className={classes.root}
      title="Testimonials"
    >
      <Container maxWidth={false}>
        <Header />
        <br />
        <br />
        <MperitoCard title={`Client Testimonials ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
          <Results testimonials={testimonials} businessInfo={businessInfo} />
        </MperitoCard>
      </Container>
    </Page>
  );
}

export default TestimonialsList;

